<template>
  <div class="login">
    <div class="logoL">
      <img src="../../../../static/images/main/loginL.png" />
    </div>
    <div class="title">
      重置密码
    </div>
    <el-form :model="myForm" :rules="rules" ref="myForm">
      <el-form-item label="原始密码" prop="oldPas" label-width="80px">
        <el-input v-model="myForm.oldPas"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPas" label-width="80px">
        <el-input v-model="myForm.newPas" show-password></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPas" label-width="80px">
        <el-input v-model="myForm.confirmPas" show-password></el-input>
      </el-form-item>
      <el-form-item class="formBtn">
        <el-button type="primary" :disabled="disable" size="medium" @click="sendForm" :class="{'disable':!disable}">重置密码</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { resetPassword } from '@/api/datas';
export default {
  name: "passwordChange",
  props: {
    dialogVisible: {
      type: Boolean,
    },
  },
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        return callback(new Error("密码不能少于6位！"));
      } else if (value.length > 16) {
        return callback(new Error("密码最长不能超过16位！"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value != this.myForm.newPas) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      myForm: {
        oldPas: "",
        newPas: "",
        confirmPas: "",
      },
      disable: true,
      rules: {
        oldPas: [{ required: true, message: "请输入原始密码", trigger: "blur" }],
        newPas: [{ required: true, validator: validatePass, trigger: "blur" }],
        confirmPas: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    'myForm.oldPas' (newVal, oldVal) {
      let newPas = this.myForm.newPas;
      let confirmPas = this.myForm.confirmPas;
      if (newPas != "" && confirmPas != "") {
        this.disable = false;
      } else {
        this.disable = true;
      }
    },
    'myForm.newPas' (newVal, oldVal) {
      let oldPas = this.myForm.oldPas;
      let confirmPas = this.myForm.confirmPas;
      if (oldPas != "" && confirmPas != "") {
        this.disable = false;
      } else {
        this.disable = true;
      }
    },
    'myForm.confirmPas' (newVal, oldVal) {
      let oldPas = this.myForm.oldPas;
      let newPas = this.myForm.newPas;
      if (oldPas != "" && newPas != "") {
        this.disable = false;
      } else {
        this.disable = true;
      }
    },
    dialogVisible (newVal, oldVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    sendForm () {
      var _that = this;
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          resetPassword({
            password: _that.myForm.oldPas,
            newPassword: _that.myForm.confirmPas,
            phoneNumber: _that.$store.state.loginDatas.phone_number
          })
            .then(res => {
              if (res.data.code == "200") {
                _that.$message({
                  message: "修改密码成功",
                  type: "success"
                });
                _that.$emit("refeshPaw", false);
              } else {
                _that.$message({
                  message: res.data.msg,
                  type: "warning"
                });
              }
            })
            .catch(res => { });
        } else {
          return false;
        }
      });
    },
    resetForm () {
      this.myForm = this.$options.data().myForm;
      this.$refs["myForm"].resetFields();
    }
  },
};
</script>
<style scoped lang="scss">
.logoL {
  display: flex;
  justify-content: center;
  img {
    width: 198px;
    height: 29px;
  }
}
.title {
  text-align: center;
  margin: 30px;
  font-weight: bold;
  font-size: 18px;
}
.login {
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 32px;
  }
  /deep/ .el-form-item--small .el-form-item__error {
    padding-top: 10px;
  }
  /deep/ .el-input__inner {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    color: #333;
    border: 1px solid #d9d9d9;
  }
  /deep/ .veCode .el-form-item__content {
    display: flex;
    .el-button {
      border-radius: 8px;
    }
  }
  /deep/ .veCode .el-input__inner {
    width: 218px;
  }
  /deep/ .formBtn .el-button {
    width: 332px;
    height: 40px;
    font-size: 14px;
    color: #333;
    background: #deedfc;
    border-radius: 20px;
    margin: 30px 0;
  }
  /deep/ .formBtn .disable {
    background: linear-gradient(180deg, #26b1f2 0%, #09cbf9 100%);
    color: #fff;
  }
  /deep/ .el-form-item__label {
    font-size: 14px;
    font-weight: 700;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/layout/component/passwordChange.vue